import axios from 'axios';

// Public instance for unauthenticated requests (e.g., login)
const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3030/api/admin';

// This instance will NOT have the authentication interceptor
const axiosPublic = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default axiosPublic;
